 <template>
  <div class="position-relative">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" style="z-index: 1042">
        <div class="custom-container-fluid px-0">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="px-4 bg-white m-3 position-relative" style="height: 95vh;overflow-y: hidden;">
                <div class="pb-2 pt-4 border-bottom">
                  <div class="d-block" @click="onClose()">
                    <img src="../../../../assets/img/icon/close.png" width="15" class="d-inline-block position-relative cursor-pointer" style="top: -2px">
                    <p class="mb-1 px-1 font-bold text-18 ls-2 d-inline-block ml-2">{{$t('merchant.term-condition')}}</p>
                  </div>
                </div>
                <div class="pt-3 popup-full" style="height:70vh">
                  <div class="mb-3 pb-4 body-2-2 text-14 font-regular html-desc" v-html="data"></div>
                </div>
                <div style="height: 12vh;" class="text-center pt-2">
                  <button type="button" class="button-secondary w-50" @click="onClose()">
                    Accept
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';

	export default{
		data(){
      return {
      	term_condition: ''
			}
		},
    computed:{
      ...mapGetters(['getMerchant']),
      data(){
        return this.$isNotEmpty(this.getMerchant.precheckin_terms_and_conditions) ? this.getMerchant.precheckin_terms_and_conditions : this.getMerchant.terms_and_conditions
      }
    },
		methods: {
      ...mapMutations(['setLanguageMutation']),
			onClose(){
				this.$emit('toggleTermCondition', false)
			}
		}
	}
</script>
<style scoped>
::placeholder {
  color: #d8d8d8;
  font-size: 14px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
 color: #d8d8d8;
 font-size: 14px;
}

::-ms-input-placeholder { /* Microsoft Edge */
 color: #d8d8d8;
 font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/termCondition.vue